import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import moment from 'moment';
import ModalComponent from '../../../ui/Modal';
import FormikRadioButtonAlternate from '../../../ui/FormikRadioButtonAlternate';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { ListingAddOnsSchema } from '../validation';
import PlusMinusNumber from '../../../ui/PlusMinusNumber';

const blankAddOn = {
  name: '',
  description: '',
  price: '',
  inventory: 1,
  totalInventory: 1,
  validDates: [],
  new: true,
  hasInventory: false,
  hasDateRange: false,
  dateRangeType: '',
  isActive: true
};

export function formatDateRange(date) {
  let startDate = moment(date.startDate).format('MM/DD');

  if (date.endDate !== null) {
    let endDate = moment(date.endDate).format('MM/DD');
    return `${startDate} - ${endDate}`;
  }

  return startDate;
}

export function CustomOverlay({ classNames, selectedDay, children, ...props }) {
  return (
    <div
      className={`${classNames.overlayWrapper} wrapper-override`}
      //style={{ marginLeft: -100 }}
      {...props}
    >
      <div className={classNames.overlay}>
        {children}
      </div>
    </div>
  );
}

export const renderDates = (values, toRef, setFieldValue, addValidDates, removeValidDate) => {
  const today = new Date();
  const cssFormControl = "form-control";
  return (
    <div className="fieldgroup row">
      <div className="col-6 col-md-5 edit-field-parent reset-padding">
        {values.hasDateRange && (
          <div className="padding-top-1rem">
            <div className="row padding-left-15">
              <FormikRadioButtonAlternate
                name="dateRangeType"
                value="single"
                label="Single Day"
                checked={values.dateRangeType === 'single'}
              />
            </div>
            <div className="row padding-left-15">
              <FormikRadioButtonAlternate
                name="dateRangeType"
                value="range"
                label="Date Range(s)"
                checked={values.dateRangeType === 'range'}
              />
            </div>
          </div>
        )}
      </div>
      <div className="col-6 col-md-7 edit-field-parent">
        {values.hasDateRange && (
          values.dateRangeType === 'single'
            ? (<div className="row">
              <span className="padding-top-input day-picker-input first-datepicker-container">
                <DayPickerInput
                  overlayComponent={CustomOverlay}
                  value={values.from}
                  onDayChange={(day) => { setFieldValue("from", day); }}
                  inputProps={{ className: cssFormControl }}
                  formatDate={formatDate}
                  parseDate={parseDate}
                  placeholder={`${formatDate(new Date())}`}
                  dayPickerProps={{
                    disabledDays: { before: today },
                    selectedDays: values.from ? values.from : undefined
                  }}
                />
              </span>
              <div className="disclaimer">
                Input first and last dates when this discount is available. Click the Save Dates button to save your changes.
                Repeat this process to create multiple date ranges.</div>
              <div className="w-100 save-dates-container text-center mt-1 mb-2">
                {!!values.from &&
                  <button className="btn-secondary save-dates-right"
                    onClick={(e) => {
                      e.preventDefault();
                      addValidDates(values, setFieldValue);
                    }}>Save Dates</button>
                }
              </div>
            </div>)
            : (<div className="row padding-top-input-extra d-flex">
              <div className="col-12 col-md-6 reset-padding">
                <DayPickerInput
                  overlayComponent={CustomOverlay}
                  value={values.from}
                  placeholder="From"
                  //format="LL"
                  dayPickerProps={{
                    selectedDays: values.from ? [values.from, { from: values.from, to: values.to }] : undefined,
                    // disabledDays: { after: to },
                    disabledDays: { before: today },
                    modifiers: { start: values.from, end: values.to },
                    onDayClick: () => toRef.getInput().focus()
                  }}
                  inputProps={{ className: cssFormControl }}
                  onDayChange={(day) => { setFieldValue("from", day); }}
                  formatDate={formatDate}
                  parseDate={parseDate}
                />
              </div>
              <div className="col-12 col-md-6 reset-padding">
                <DayPickerInput
                  ref={el => (toRef = el)}
                  overlayComponent={CustomOverlay}
                  value={values.to}
                  placeholder="To"
                  //format="LL"
                  dayPickerProps={{
                    selectedDays: values.to ? [values.from, { from: values.from, to: values.to }] : undefined,
                    disabledDays: { before: values.from },
                    modifiers: { start: values.from, end: values.to },
                    month: values.from,
                  }}
                  inputProps={{ className: cssFormControl }}
                  onDayChange={(day) => { setFieldValue("to", day); }}
                  formatDate={formatDate}
                  parseDate={parseDate}
                />
              </div>
              <div className="disclaimer">Input first and last dates when this discount is available.
                Click the Save Dates button to save your changes. Repeat this process to create multiple date ranges.</div>
              <div className="w-100 save-dates-container text-center mt-1 mb-2">
                {!!values.from &&
                  <button className="btn-secondary save-dates-right" onClick={(e) => {
                    e.preventDefault();
                    addValidDates(values, setFieldValue);
                  }}>Save Dates</button>
                }
              </div>
            </div>)
        )}
        <div className="row d-flex flex-column align-items-center">
          {values.hasDateRange && values.validDates.map((date, i) => {
            return <div key={`validDate-${i}`} className="d-flex align-content-center">
              <span className="date-range-short">{formatDateRange(date)}</span>
              <i className="fas fa-times" onClick={() => {
                removeValidDate(values, date, setFieldValue);
              }}></i>
            </div>
          })}
        </div>
      </div>
    </div>
  )
}

export const addValidDates = (values, setFieldValue) => {
  let validDates = values.validDates;
  let fromNew = new Date(values.from.toISOString());
  let toNew = values.to !== undefined ? new Date(values.to.toISOString()) : null;

  let dupe = validDates.find(x =>
    Date.parse(x.startDate) === Date.parse(fromNew)
    && ((!toNew && !x.endDate) || (Date.parse(x.endDate) === Date.parse(toNew)))
  );

  if (!dupe) {
    validDates.push({
      startDate: fromNew,
      endDate: toNew
    });
  }

  setTimeout(() => {
    setFieldValue('validDates', validDates);
    setFieldValue('from', undefined);
    setFieldValue('to', undefined);
  }, 240);
}

export const removeValidDate = (values, date, setFieldValue) => {
  let dateIndex = values.validDates.findIndex(vd => Date.parse(vd.startDate) === Date.parse(date.startDate)
    && ((!date.endDate && !vd.endDate) || (Date.parse(vd.endDate) === Date.parse(date.endDate))))
  if (dateIndex > -1) { values.validDates.splice(dateIndex, 1); }
  setTimeout(() => {
    setFieldValue('validDates', values.validDates);
  }, 240)
}

class AddOnModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      validDatesStatusYes: true,
      validDatesStatusNo: false
    }

    this.onSubmit = this.onSubmit.bind(this);
  }
  bindSubmitForm = (submitForm) => { this.submitForm = submitForm; }
  handleFormSubmit = (e) => { if (this.submitForm) { this.submitForm(e); } }
  onSubmit = (values) => {
    if (!values.hasInventory) {
      values.inventory = 0;
      values.totalInventory = 0;
    }
    else { values.totalInventory = values.inventory; }
    this.props.onSubmit(values);
    this.toRef = null;
  }

  renderBody = (bindSubmitForm, onSubmit) => {
    let initialValues = this.props.addOn ? this.props.addOn : blankAddOn;
    if (!this.props.addOn) { initialValues.validDates = []; }
    if (initialValues.validDates.length > 0) { initialValues.hasDateRange = true; }
    if (initialValues._id && initialValues.inventory > 0) { initialValues.hasInventory = true; }
    initialValues.dateRangeType = 'single';

    return (<div>
      <div className="col-12" className="discounts">
        <Formik
          initialValues={initialValues}
          validationSchema={ListingAddOnsSchema}
          onSubmit={onSubmit}>
          {({ values, errors, setFieldValue, submitForm }) => {
            bindSubmitForm(submitForm);
            return (<Form>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Title</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="row">
                    <Field
                      name="name"
                      type="text"
                      placeholder="ex. Museum Tickets"
                      className="form-control form-field"
                    />
                    <ErrorMessage name="name" component="div" className="error-message" />
                  </div>
                </div>
              </div>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 reset-padding">
                  <div className="field-title">Description</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="row">
                    <Field
                      name="description"
                      type="text"
                      component="textarea"
                      placeholder=""
                      className="form-control form-field addon-textarea"
                    />
                    <ErrorMessage name="description" component="div" className="error-message" />
                  </div>
                </div>
              </div>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Price (per 1 item)</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="row">
                    <span className="dollar-field-addon">
                      <Field
                        name="price"
                        type="text"
                        placeholder=""
                        className="form-control form-field"
                      />
                    </span>
                    <ErrorMessage name="price" component="div" className="error-message" />
                  </div>
                </div>
              </div>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Inventory</div>
                  <div className="field-description">Is there a limited quantity of this add-on?</div>
                </div>
                <div className="col-6 col-md-7 edit-field-parent">
                  <div className="edit-radio-button-container">
                    <div className="row">
                      <div className="col-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasInventory"
                          value={true}
                          label="Yes"
                          checked={values.hasInventory}
                        />
                      </div>
                      <div className="col-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasInventory"
                          value={false}
                          label="No"
                          checked={!values.hasInventory}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {values.hasInventory && (<div className="fieldgroup row">
                <div className="col-6 col-md-5 reset-padding">
                  <div className="field-title quantity">Quantity</div>
                </div>
                <div className="col-6 col-md-7">
                  <PlusMinusNumber
                    name="inventory"
                    num={values.inventory}
                    className="field-control plus-minus-offset"
                    callBack={(form, field, num) => {
                      let newVal = values.inventory + num;
                      if (newVal < 1) newVal = 1;
                      setFieldValue('inventory', newVal);
                      setFieldValue('')
                    }}
                    incrementBy="1" />
                </div>
              </div>
              )}
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="row padding-left-15">
                    <div className="field-title">Valid Dates</div>
                    <div className="field-description">Is this discount only available on certain dates?</div>
                  </div>
                </div>
                <div className="col-6 col-md-7 edit-field-parent">
                  <div className="edit-radio-button-container">
                    <div className="row">
                      <div className="col-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasDateRange"
                          value={true}
                          label="Yes"
                          checked={values.hasDateRange}
                        />
                      </div>
                      <div className="col-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasDateRange"
                          value={false}
                          label="No"
                          checked={!values.hasDateRange}
                        />
                      </div>
                    </div>
                    {!values.hasDateRange && (<div className="row"><div className="disclaimer">
                      If you do not set dates, the code will be valid as soon as you save it and will never expire.</div></div>)}
                  </div>
                </div>
              </div>
              {renderDates(values, this.toRef, setFieldValue, addValidDates, removeValidDate)}
            </Form>);
          }}
        </Formik>
      </div>
    </div>);
  }

  renderButtonRow(onClose, buttonText) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-center pl-0">
          <label onClick={onClose}>Cancel</label>
        </div>
        <div className="col text=center">
          <button className='btn btn-primary' onClick={this.handleFormSubmit} >{buttonText}</button>
        </div>
      </div>
    )
  }

  render() {
    let { onClose, errType, errors, addOn } = this.props;

    let error = (errType && errors) ? errors.find(e => e.errType === errType) : null;
    let title = addOn ? 'Editing AddOn' : 'Creating AddOn';
    let buttonText = addOn ? 'Update AddOn' : 'Create AddOn';
    return (<ModalComponent
      id="AddOnModal"
      title={title}
      body={this.renderBody(this.bindSubmitForm, this.onSubmit, error)}
      footer={this.renderButtonRow(onClose, buttonText)}
      noMinHeight={true}
      onClose={onClose} />
    );
  }
}

export default AddOnModalComponent;
